import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FOR_INVESTORS_SECTIONS, FOR_INVESTORS_SUB_SECTIONS } from 'constants/businessToolSections/forInvestors';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';
import { GLOBAL_FIELD_NAMES, globalPrefix } from 'components/BusinessToolForm/Sections/Global/form';
import {
  prefix,
  PRODUCTS_AND_SERVICES_ADVANTAGES_NAMES,
} from 'components/BusinessToolForm/Sections/ProductsAndServices/ProductAndServicesAdvantages/utils/form';

import { concatWithDot } from 'helpers/string';

export const Uniqueness: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS,
    FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_BUSINESS_OPERATIONS.UNIQUENESS,
  );

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('businessOperations.title')}
          badgeText={t('productsAndServicesForm.uniqueness.title')}
          section={FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('productsAndServicesForm.uniqueness.specifyUniqueness')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.COMPETITIVE_ADVANTAGE)}
      >
        {/* 3.2.1 */}
        <TextInputControl
          multiline
          control={control}
          id="productsAndServicesForm.uniqueness"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.COMPETITIVE_ADVANTAGE)}
          minRows={3}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('productsAndServicesForm.uniqueness.whatValueToTheCustomer')}
        aiFieldName={concatWithDot(prefix, PRODUCTS_AND_SERVICES_ADVANTAGES_NAMES.PRODUCT_VALUE)}
      >
        {/* 3.2.3 */}
        <TextInputControl
          multiline
          control={control}
          id="productsAndServicesForm.productValue"
          name={concatWithDot(prefix, PRODUCTS_AND_SERVICES_ADVANTAGES_NAMES.PRODUCT_VALUE)}
          minRows={3}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
    </>
  );
};
